import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var HomeFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M43.825 20.826c-.3.4-.9.4-1.2.1L39.32 18.33v19.374c0 1.998-1.902 3.296-3.904 3.296h-8.809V27.917c0-1.698-1.401-2.996-3.103-2.996h-3.103c-1.702 0-3.103 1.398-3.103 2.996V41h-8.81c-2.001 0-3.903-1.298-3.903-3.296V18.33l-3.203 2.596c-.4.3-.901.2-1.202-.1-.3-.399-.2-.898.1-1.198L20.501 3.45c.902-.599 2.003-.599 2.904 0l20.22 16.08c.4.299.5.898.2 1.297Z"
  }));
});
HomeFill.displayName = 'HomeFill';
HomeFill.defaultProps = {
  'aria-label': 'HomeFill'
};
export default HomeFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/HomeFill.js
// module id = 3185
// module chunks = 11